import { request } from "../utils/request.js"

export const customizeCollectOrder_exportForManage = (pojo, args) => request({
    url: 'customizeCollectOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


export const customizeCollectOrder_findPageForManage = (pojo, args) => request({
    url: 'customizeCollectOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeCollectOrder_findPageListForManage = (pojo, args) => request({
    url: 'customizeCollectOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeCollectOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'customizeCollectOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeCollectOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'customizeCollectOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customizeCollectOrder_saveIntoDraft = (pojo, args) => request({
    url: 'customizeCollectOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeCollectOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'customizeCollectOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeCollectOrder_update = (pojo, args) => request({
    url: 'customizeCollectOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeCollectOrder_updateAndSubmit = (pojo, args) => request({
    url: 'customizeCollectOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeCollectOrder_submitById = (id, args) => request({
    url: 'customizeCollectOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeCollectOrder_deleteById = (id, args) => request({
    url: 'customizeCollectOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customizeCollectOrder_approval = (pojo, args) => request({
    url: 'customizeCollectOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


export const customizeCollectOrder_findById = (id, args) => request({
    url: 'customizeCollectOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const customizeCollectOrder_findVoById = (id, args) => request({
    url: 'customizeCollectOrder/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/customizeCollectOrder.js